import React, { useState } from 'react';
import { connect } from 'react-redux';

import ProfileSidebar from '../../../Components/Profile/ProfileSidebar';
import SpecialityModal from '../../../Components/UI/Modal/SpecialityModal';
import RegionModal from '../../Boutique/RegionModal';
import { artisanRegistrationLabel } from '../../../Utils/artisanStatus';
import { regionLabel } from '../../../Config/franceRegions';
import { useI18n } from '../../../i18n/I18nProvider';

const specialityCode = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (!normalized) return 'general';
  if (['window', 'windows', 'menuiserie', 'carpentry', 'joinery'].some((token) => normalized.includes(token))) return 'window';
  if (['electricity', 'electrical', 'électricité', 'electricite'].some((token) => normalized.includes(token))) return 'electricity';
  if (['plumbing', 'plomberie'].some((token) => normalized.includes(token))) return 'plumbing';
  if (['painting', 'peinture'].some((token) => normalized.includes(token))) return 'painting';
  if (['masonry', 'maçonnerie', 'maconnerie'].some((token) => normalized.includes(token))) return 'masonry';
  if (['roofing', 'couverture', 'toiture'].some((token) => normalized.includes(token))) return 'roofing';
  if (['heating', 'chauffage'].some((token) => normalized.includes(token))) return 'heating';
  if (['renovation', 'rénovation'].some((token) => normalized.includes(token))) return 'renovation';
  return 'general';
};

const LeftJobSection = ({ profile }) => {
  const { language, t } = useI18n();
  const [showSpeciality, setShowSpeciality] = useState(false);
  const [showRegion, setShowRegion] = useState(false);
  const speciality = t(`specialities.${specialityCode(profile.speciality)}`);

  return (
    <>
      <ProfileSidebar
        profile={profile}
        editPath="/profileartisan"
        showRating
        details={[
          { label: t('profileSidebar.speciality'), value: speciality, onClick: () => setShowSpeciality(true) },
          { label: t('profileSidebar.region'), value: regionLabel(profile.artisan_region), onClick: () => setShowRegion(true) },
          {
            label: t('profileSidebar.status'),
            value: artisanRegistrationLabel(profile.registration_status, language),
          },
        ]}
      />
      <SpecialityModal showModal={showSpeciality ? 'open' : 'close'} handleClick={() => setShowSpeciality(false)} />
      <RegionModal showModal={showRegion ? 'open' : 'close'} handleClick={() => setShowRegion(false)} />
    </>
  );
};

const mapStateToProps = ({ firebase }) => ({ profile: firebase.profile || {} });
export default connect(mapStateToProps)(LeftJobSection);
